export interface DMZConfig {
  id: string;
  org_id: string;
  site_id?: string | null;
  zone_id?: string | null;
  system_id?: string | null;
  cloud_service_id?: string | null;
  label: string;
  description?: string | null;
  position_x?: number | null;
  position_y?: number | null;
  parent_node_id?: string | null;
  owner_id?: string | null;
  created_at: string;
  updated_at: string;
  created_by?: string | null;
  updated_by?: string | null;
  rules?: FirewallRule[];
}

export interface DMZConfigInsert {
  label: string;
  site_id?: string | null;
  zone_id?: string | null;
  system_id?: string | null;
  cloud_service_id?: string | null;
  description?: string | null;
  position_x?: number | null;
  position_y?: number | null;
  parent_node_id?: string | null;
  owner_id?: string | null;
}

export interface DMZConfigUpdate extends Partial<DMZConfigInsert> {}

export type DMZParentType = 'site' | 'zone' | 'system' | 'cloud_service';

export interface FirewallRule {
  id: string;
  org_id: string;
  dmz_config_id: string;
  chain: FirewallChain;
  source: string;
  destination: string;
  port?: string | null;
  protocol: string;
  action: FirewallAction;
  rule_order: number;
  notes?: string | null;
  created_at: string;
  updated_at: string;
}

export interface FirewallRuleInsert {
  dmz_config_id: string;
  chain: FirewallChain;
  source?: string;
  destination?: string;
  port?: string | null;
  protocol?: string;
  action: FirewallAction;
  rule_order?: number;
  notes?: string | null;
}

export interface FirewallRuleUpdate extends Partial<Omit<FirewallRuleInsert, 'dmz_config_id'>> {}

export const FIREWALL_CHAINS = ['INPUT', 'FORWARD', 'OUTPUT'] as const;
export type FirewallChain = typeof FIREWALL_CHAINS[number];

export const FIREWALL_ACTIONS = ['ALLOW', 'DENY', 'DROP'] as const;
export type FirewallAction = typeof FIREWALL_ACTIONS[number];

export const PROTOCOLS = ['TCP', 'UDP', 'ICMP', 'ANY'] as const;
export type Protocol = typeof PROTOCOLS[number];
